<div class="demo-full-width margin-top" [formGroup]="group" >
    <mat-checkbox [formControlName]="field.name" (change)="onChange($event)">{{field.label}}</mat-checkbox>
    </div>
